module.exports = __webpack_public_path__ + "img/smartscreen3_512x512.1195f30e.png";